export const PINNED_COLUMN_CLASSES = {
	left: 'sticky left-0 bg-container-bg group-hover:bg-button-disabled z-10',
	right: 'sticky right-0 bg-container-bg group-hover:bg-button-disabled z-10',
} as const;

export const PINNED_COLUMN_STUCK_CLASSES = {
	left: "before:content-[''] before:absolute before:left-full before:top-0 before:h-full before:w-8 before:bg-gradient-to-r before:from-[var(--color-container-bg)] group-hover:before:from-[var(--color-button-disabled)] before:to-transparent before:pointer-events-none",
	right:
		"before:content-[''] before:absolute before:right-full before:top-0 before:h-full before:w-8 before:bg-gradient-to-l before:from-[var(--color-container-bg)] group-hover:before:from-[var(--color-button-disabled)] before:to-transparent before:pointer-events-none",
} as const;

export const TABLE_DEFAULT_EMPTY_MESSAGE = 'No data found';
